export const channelActionType = {
    zipCodeSuccess: 'ZIP_CODE_DATA',
    allPackageSuccess: 'ALL_PACKAGE_DATA',
    searchChannelSuccess: "SEARCH_CHANNEL_DATA",
    compareChannelSuccess: "COMPARE_CHANNEL_DATA",
    packageViewByNameSuccess: "PACKAGE_VIEW_NAME_DATA",
    loaderSuccess:'LOADER_ACTIVE'
}